import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const lossNumberApi = createApi({
  reducerPath: 'lossNumber',
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ['LossNumber'],
  endpoints: (builder) => ({
    getAllLossNumber: builder.query({
      query: () => 'accountSetup/numberOfLosses',
      transformResponse: (res) => res.data,
      providesTags: ['LossNumber'],
    }),
    addNewLossNumber: builder.mutation({
      query: (data) => ({
        url: `accountSetup/numberOfLosses`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: data,
      }),
      invalidatesTags: ['LossNumber'],
    }),
    updateLossNumber: builder.mutation({
      query: ({ id, data }) => ({
        url: `accountSetup/numberOfLosses/${id}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: data,
      }),
      invalidatesTags: ['LossNumber'],  
    }),

    deleteLossNumber: builder.mutation({
      query: (id) => ({
        url: `accountSetup/numberOfLosses/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['LossNumber'],
    }),
  }),
});

export const {
  useGetAllLossNumberQuery,
  useAddNewLossNumberMutation,
  useUpdateLossNumberMutation,
  useDeleteLossNumberMutation,
} = lossNumberApi;
